import { Col,Row } from "antd";
import React from 'react';

import LargePostItem from "../PostItem/PostItemMostView/LargePostItemPageCate";
import SmallPostItem from '../PostItem/PostItemMostView/SmallPostItem';
import TitleSection from '../TitleSection';

const MostViewPostGroup = ({ title, posts, isMore }) => {
  return (
    <div >
      <TitleSection title={title} isMore={isMore} />
      <Row gutter={[20, 0]}>
        <Col span={24}>
          <LargePostItem post={posts[0]} />
          {posts.slice(1, 5).map(item => {
            return <SmallPostItem post={item} key={item.slug} />
          })}
        </Col>
        </Row>
    </div>
  )
}
export default MostViewPostGroup;
